import React from "react";
import "./TaskDemonstration.css";

export interface TaskDemonstrationProps {
  children: React.ReactNode;
  disabled?: boolean;
}

export const TaskDemonstration: React.FC<TaskDemonstrationProps> = ({
  children,
  disabled = false
}) => {
  return (
    <div className={`task-demonstration ${disabled ? 'disabled' : ''}`}>
      {children}
    </div>
  );
};
